import { CustomField, CustomFieldFieldLabels, CustomFieldFilters } from "../../../api/CustomFields/CustomFields";
import { DefinedPropertyObject } from "../../../api/GenericTypes";
import { GenericVirtualizedSelectFormField } from "../../../common/formfields/GenericVirtualizedSelectFormField/GenericVirtualizedSelectFormField";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { AbstractedCustomFieldDataTypeIcon } from "../CustomFieldRenderUtils";
import {
  AbstractedCustomFieldDataTypes,
  AbstractedCustomFieldDataTypesConsts,
  abstractedDataTypeToFilter,
  generateAbstractedFromDataType,
} from "../CustomFieldUtils";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import { CombinedModificationRecordEntityFilterForm } from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
import { defaultCustomFieldsFilters } from "./CustomFieldsTable";

export interface CustomFieldFilterForm extends ICombinedModificationRecordEntityForm {
  dataType?: AbstractedCustomFieldDataTypes[] | undefined | null;
}
const defaultValues: DefinedPropertyObject<CustomFieldFilterForm> = {
  dataType: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
};
export const customFieldFormToFilters = (form: CustomFieldFilterForm): CustomFieldFilters => {
  let filters: CustomFieldFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
  };
  filters.dataTypes =
    Array.isArray(form.dataType) && form.dataType.length > 0
      ? form.dataType?.map((d: AbstractedCustomFieldDataTypes) => abstractedDataTypeToFilter(d)).flat()
      : null;
  return filters;
};
/**
 * Converts CustomFieldFilters to CustomFieldFilterForm
 * @param filters CustomFieldFilters
 * @returns CustomFieldFilterForm
 * @author @CorradoSurmanowicz
 */
export const customFieldFiltersToForm = (filters: CustomFieldFilters): CustomFieldFilterForm => {
  return {
    dataType: filters.dataTypes
      ? (filters.dataTypes
          .map((dataType) => generateAbstractedFromDataType(dataType).abstractedDataType)
          .filter((v) => v) as AbstractedCustomFieldDataTypes[])
      : null,
    ...combinedModificationRecordEntityFiltersToForm(filters),
  };
};

export const CustomFieldsFilterBar = ({
  initialValues,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<CustomField, CustomFieldFilterForm, CustomFieldFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultCustomFieldsFilters}
      formToFilters={customFieldFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <GenericVirtualizedSelectFormField
            id={"dataType"}
            label={CustomFieldFieldLabels.dataType}
            items={AbstractedCustomFieldDataTypesConsts.map((e) => e)}
            control={control}
            placeholder={"Select data type"}
            onRowStartRenderer={(row) => <AbstractedCustomFieldDataTypeIcon dataType={row} />}
            isMulti
          />

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
